import React from "react";
import { observer } from "mobx-react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import AuthStore from "stores/AuthStore";

import BackgroundLight from "components/Layout/Background/BackgroundLight";
import Paper from "components/Layout/Paper";
import FormControl, { TextFieldControl } from "components/FormControl";
import SubmitButtonControl from "components/FormControl/SubmitButtonControl";
import LoadingButton from "components/LoadingButton";
import { SNACKBAR_TYPES } from "components/Snackbar";

import {
  withGlobalSnackbar,
  SnackbarContextProps,
} from "services/snackbar/snackbarContext";

import ROUTES from "navigation/routes";

import { Container, Content, Logo, Row, ButtonWrapper } from "./styles";

type Props = RouteComponentProps & SnackbarContextProps & {};

@observer
class Login extends React.Component<Props> {
  onLogin = async (values: any) => {
    const { history, setMessage } = this.props;
    const { email, password } = values;

    try {
      await AuthStore.login(email, password);
      history.push(ROUTES.IN_APP_STUDIO);
    } catch (error) {
      setMessage(error?.message, SNACKBAR_TYPES.ERROR);
    }
  };

  render() {
    return (
      <Container>
        <BackgroundLight />
        <Paper>
          <Content>
            <Logo />

            <FormControl onSubmit={this.onLogin}>
              <Row>
                <TextFieldControl
                  variant="outlined"
                  margin="none"
                  required
                  fullWidth
                  label="Username"
                  name="email"
                />
              </Row>

              <Row>
                <TextFieldControl
                  variant="outlined"
                  margin="none"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  autoComplete="current-password"
                />
              </Row>

              <ButtonWrapper>
                <SubmitButtonControl render={this.renderButton} />
              </ButtonWrapper>
            </FormControl>
          </Content>
        </Paper>
      </Container>
    );
  }

  renderButton = ({ onClick }: { onClick: () => void }) => (
    <LoadingButton
      onClick={onClick}
      fullWidth
      variant="contained"
      color="primary"
      isLoading={AuthStore.isLoading}
    >
      Login
    </LoadingButton>
  );
}

export default withRouter(withGlobalSnackbar(Login));
